<template>
  <v-dialog v-model="visible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="item">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`案件編號`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.displayId"
              :disabled="!isNew"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`姓名`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.name"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`身份證`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.memberId"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`電話`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.cellphone"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`車牌`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.carId"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`招攬通路`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.vendorName"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              type="number"
              :label="`申辦金額`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.totalCreditPrice"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              type="number"
              :label="`月付金`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.creditPriceMonth"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              type="number"
              :label="`期數`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.installmentsNumber"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md6>
            <v-autocomplete
                            v-model="editedItem.agentId"
                            background-color="#49bcfd"
                            outline
                            :items="agentList"
                            label="經辦人"
                            item-text="displayName"
                            item-value="agentId"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="files.length < 8">
              <input ref="files"
                     type="file" :name="uploadFieldName"
                     @change="handleFilesUpload()"
                     accept="image/*,.xlsx,.xls,.csv,.pdf,.doc,.docx,.ppt,.pptx" hidden>
              <v-btn color="success" dark text @click="chooseFile">新增檔案</v-btn>
            </div>
          </v-flex>
          <v-flex xs12 v-if="message !==''">
            <span style="color: red;">{{ message }}</span>
          </v-flex>
          <v-flex xs12 v-if="files.length">
            <div v-for="file of files">
              <span >{{ file.name }}</span><br>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL1 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL1" target="_blank">檔案1</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL2 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL2" target="_blank">檔案2</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL3 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL3" target="_blank">檔案3</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL4 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL4" target="_blank">檔案4</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL5 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL5" target="_blank">檔案5</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL6 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL6" target="_blank">檔案6</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL7 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL7" target="_blank">檔案7</a>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="editedItem.fileURL8 !==''">
          <v-flex md12>
            <a :href="editedItem.fileURL8" target="_blank">檔案8</a>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" dark text v-if="!isNew" @click="deleteEvent">刪除</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelEvent">取消</v-btn>
        <v-btn color="primary" :loading="loading" dark text @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from 'vuex';
import DatePicker from "@/components/DatePicker";
import common from '@/mixins/common';
import CaseFinanceModel from '@/models/CarFinanceModel';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'CarFinanceDialog',
  components:{ DatePicker },
  props: {
    visible: Boolean,
    title: String,
    item: Object,
    isNew: Boolean,
    loading: Boolean,
  },
  mixins:[common],
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      type: 0,
      menu: false,
      fileList:[],
      uploadFieldName: 'files',
      files: [],
      message: '',
      agentItems: [],
    };
  },
  created() {
  },
  computed: {
    ...mapGetters(["getUserInfo",'getAgentList']),
    editedItem() {
      return this.item;
    },
    agentList(){
      return this.getAgentList.filter(agent=>agent.enable === true);
    },
  },
  watch: {
    visible(value) {
      console.log(`car finance visible = ${value}`);
      if (this.isNew){
        this.item.agentId = this.getUserInfo.agentId;
        this.item.category = 0;
      }
      if (value){
        this.files = [];
        this.fetchAgentList();
      }
    },
    loading(value) {
      console.log(`car finance loading = ${value}`);
    }
  },
  methods: {
    ...mapActions(['fetchAgentList',]),
    chooseFile(){
      this.$refs.files.click();
    },
    handleFilesUpload() {
      console.log('handleFilesUpload');
      for (let file of Array.from(this.$refs.files.files)){
        this.files.push(file);
      }
      this.$refs.files.value = null;
      console.log(this.files);
      if (this.files.length > 8){
        this.message = '檔案最多8個!'
        return;
      }
      // this.files = this.$refs.files.files;
    },
    confirmEvent() {
      this.message = '';

      if (!this.editedItem.name || this.editedItem.name === ''){
        this.showMessageDialog('請輸入姓名！')
        return;
      }

      if (!this.editedItem.memberId || this.editedItem.memberId === ''){
        this.showMessageDialog('請輸入身份證！')
        return;
      }

      if (!this.editedItem.totalCreditPrice || this.editedItem.totalCreditPrice ===''){
        this.showMessageDialog('請輸入申辦金額！')
        return;
      }

      this.$emit("confirmEvent", { item: this.editedItem, files: this.files });
    },
    cancelEvent() {
      this.files = [];
      this.message = '';
      this.$emit("cancelEvent");
    },
    deleteEvent(){
      this.$emit("deleteEvent", this.editedItem.caseId);
    },
    isImage(name){
      return name.includes('.jpg') || name.includes('.png') || name.includes('.jpeg');
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CarFinanceDialog.vue